import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import NumberFormat from 'react-number-format';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

import PaymentCreditMemo from './PaymentCreditMemo';
import PaymentCreditTableHead from './PaymentCreditEnhancedTable';
import CurrencyInputFormat from './CurrencyInputFormat';

import { fetchCredit, toggleCredit, 
    toggleAllCredit, changePaymentAmount } from './actions/credit';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        position: 'relative',
        margin:6,
        padding:6
    },
    disabled: {
        pointerEvents: 'none',
        opacity: 0.5,
        filter: 'grayscale(0.5)',
    },
    table: {
        // minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
        padding: 0
    },
    linearProgress: {
        position: 'absolute',
        width: '100%',
    },
    paginationToolbar: {
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 2,
        }
    },
    paginationActions: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: 4,
        }
    },
    currencyInput: {
        padding: '0 4px',
        width: 96,
        [theme.breakpoints.up('sm')]: {
            padding: '0 8px',
            width: 150,
        }
    },
    tableCell:{
        paddingRight:'5px'
    }
});

class PaymentTable extends Component {

    constructor(props) {
        super(props);
        let currencies = props.customer.availableCurrencies.map((currency, index) => {
            return currency === props.customer.currencyCode && {
                name: currency,
                selected: currency === props.customer.currencyCode
            }
        })
        let columns = invoiceColumns;
        if (isWidthDown('sm', this.props.width)) {
            columns = columns.map(column => {
                return { ...column, display: column.mobileDisplay }
            })
        }
        this.state = {
            currencies,
            columns,
            order: 'asc',
            orderBy: 'invoiceDate',
            page: 0,
            rowsPerPage: 5,
        };

        this.props.fetchCredit(currencies.find(currency => currency.selected).name);
    }

    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.startTime !== this.state.startTime) {
    //         this.setState({ startTime: nextProps.startTime });
    //     }
    // }

    toggleColumns = option => {
        this.setState(prevState => {
            let columns = prevState.columns.map(value => {
                if (value === option) {
                    value.display = !option.display;
                }
                return value;
            });
            return { columns }
        })
    }

    toggleCurrency = value => {
        this.setState(prevState => {
            let currencies = prevState.currencies.map((currency, index) => {
                return {
                    name: currency.name,
                    selected: value === index
                }
            });
            this.props.fetchCredit(currencies.find(currency => currency.selected).name);
            return { currencies }
        })
    }

    redirectTocreditMemo(e,credit,column){
        console.log(credit[column.id]);
        e.preventDefault();
        e.stopPropagation()
        let redirectURL = '/creditmemo-info/'+credit[column.id];
        let win = window.open(redirectURL, '_blank');
        win.focus();
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handlePaymentAmountInput = (event, credit) => {
        this.props.changePaymentAmount(credit.entryNo, event.target.value);
    };

    handlePaymentAmountInputValidation = (credit) => {
        if (this.props.paymentAmounts[credit.entryNo] > credit.netAmount || this.props.paymentAmounts[credit.entryNo] <= 0) {
            this.props.changePaymentAmount(credit.entryNo, credit.netAmount);
        }
    };

    getTableRow = (credit) => {
        const columnsToBeDisplayed = this.state.columns.filter(column => column.display);
        const { paymentAmounts,classes } = this.props;
         let tableCells = columnsToBeDisplayed.map(column => {
            if (column.id === 'netAmount') {
                return (
                    <TableCell key="netAmount"  numeric={column.numeric}>
                        <NumberFormat 
                            value={paymentAmounts[credit['entryNo']]}                                                                                                          
                            fixedDecimalScale={true}  decimalScale={2}  displayType={'text'}  thousandSeparator={true} prefix={this.props.customer.currencyCode === 'CAD'?'CAD ':'$'}                                                   
                        />
                    </TableCell>
                )
            }
            return (
                <TableCell key={column.id} padding="none" numeric={column.numeric}>
                    {column.name.indexOf ('Transaction Number') !== -1 ? (
                        <span style={{color:'#fa451c',cursor:'pointer',WebkitTextFillColor:'#fa451c'}} onClick={(e)=>this.redirectTocreditMemo(e, credit,column)}>
                          {credit[column.id]}
                        </span>
                    ) : column.name.indexOf('Amount') === -1 ? (
                        credit[column.id]
                    ) : 
                    // (
                    //         <NumberFormat value={credit[column.id]}
                    //             fixedDecimalScale={true}
                    //             decimalScale={2}
                    //             displayType={'text'} thousandSeparator={true} prefix={'$'} />
                    //     )
                null}
                </TableCell>
            )
        })

        return (
            <TableRow
                hover
                role="checkbox"
                aria-checked={false}
                tabIndex={-1}
                key={credit.entryNo}
                selected={credit.selected}
                onClick={event => this.props.toggleCredit(credit.entryNo)}
                className={classNames({
                    [this.props.classes.disabled]: this.props.adhocPaymentEnabled,
                })}
            >
                <TableCell padding="none">
                    <Checkbox checked={credit.selected} />
                </TableCell>
                {tableCells}
            </TableRow>
        )
    }

    getSorting(order, orderBy) {
      
        return(order === 'desc'
        ? (a, b) => {
            if(orderBy === 'netAmount'){

                return ((parseFloat(b[orderBy]) < parseFloat(a[orderBy])) ? -1 : 1)

            }else if(orderBy === 'invoiceDate'){

                return ((new Date(b[orderBy]) < new Date(a[orderBy])) ? -1 : 1)

            }else{
                return (b[orderBy] < a[orderBy] ? -1 : 1)
            }
        }
        : (a, b) => {
            if(orderBy === 'netAmount'){
                return ((parseFloat(a[orderBy]) < parseFloat(b[orderBy])) ? -1 : 1)

            }else if(orderBy === 'invoiceDate'){

                return ((new Date(a[orderBy]) < new Date(b[orderBy])) ? -1 : 1)

            }else{
                return (a[orderBy] < b[orderBy] ? -1 : 1)
            }
            }
            
            )


        // return order === 'desc'
        //     ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
        //     : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
    }

    render() {
        const { classes, fetchingcredit, credit,invoices,paymentAmounts,invoicePaymentAmount} = this.props;
        const { currencies, columns, order, orderBy, page, rowsPerPage } = this.state;
        const columnsToBeDisplayed = columns.filter(column => column.display);
        const selectedcredit = credit.filter(credit => credit.selected);
        const totalAccountBalance = credit.reduce((accumulator, credit) => accumulator + (+Math.abs(credit.netAmount)), 0);
        const totalInvoicePayableBalance = invoices.reduce((accumulator, invoice) => accumulator + (+Math.abs(invoice.netAmount)), 0);
        const totalInvoiceAmount = invoices.filter(invoice => invoice.selected).reduce((accumulator,invoice) => {
            return accumulator + (+invoicePaymentAmount[invoice.entryNo])
   },0);
        const totalCreditAmount = credit.filter(credit => credit.selected).reduce((accumulator,credit) => {
            return accumulator + (+paymentAmounts[credit.entryNo])
   },0);
        const totalPayableAmount = totalInvoiceAmount -  totalCreditAmount;
        const totalPaymentAmount = totalInvoicePayableBalance -  totalAccountBalance;
        return (
            <Paper className={classes.root}>
                {fetchingcredit && <LinearProgress color="secondary" className={classes.linearProgress} />}
                <div className={classNames({
                    [classes.disabled]: fetchingcredit,
                })}>
                    <PaymentCreditMemo numSelected={selectedcredit.length}
                        columns={columns} toggleColumns={this.toggleColumns}
                        currencies={currencies} toggleCurrency={this.toggleCurrency}
                        unselectAll={(event) => this.props.toggleAllCredit(false)}
                        adhocPaymentEnabled={this.props.adhocPaymentEnabled}
                    />
                    <div className={classes.tableWrapper}>
                        <Table className={`${classes.table} creditMemoInfo`} aria-labelledby="tableTitle">
                            <PaymentCreditTableHead
                                numSelected={selectedcredit.length}
                                columns={columnsToBeDisplayed}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={(event, checked) => this.props.toggleAllCredit(checked)}
                                onRequestSort={this.handleRequestSort}
                                rowCount={credit.length}
                                adhocPaymentEnabled={this.props.adhocPaymentEnabled}
                            />
                            <TableBody>
                                {credit
                                    .sort(this.getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map(this.getTableRow)}
                                {credit.length === 0 && <TableRow style={{ height: 49 * 3 }}>
                                    <TableCell colSpan={columns.length + 1}>
                                        <Typography variant="body2" align="center" gutterBottom>
                                            {fetchingcredit ? 'Finding open credit, please wait...' : 'No Payment/Credit Memo at the moment'}
                                        </Typography>
                                    </TableCell>
                                </TableRow>}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <TablePagination
                    classes={{toolbar: classes.paginationToolbar, actions: classes.paginationActions}}
                    component="div"
                    count={credit.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
                        <Grid container spacing={24} justify="space-around" >                       
                        <Grid style={{paddingLeft:'25px'}} item xs={6}>
                        {totalAccountBalance > 0 && <Typography variant="subheading">
                    <NumberFormat value={totalAccountBalance}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        displayType={'text'} thousandSeparator={true} prefix={this.props.customer.currencyCode === 'CAD' ? 'Total Payment/Credit Memo: CAD ' : 'Total Payment/Credit Memo: $'}
                    />
                </Typography>}
                        </Grid>                                              
                        <Grid style={{paddingRight:'25px'}} item xs={6}>
                        {totalCreditAmount > 0 &&   
                        <Typography variant="subheading" align="right">
                    <NumberFormat value={totalCreditAmount}
                    fixedDecimalScale={true} decimalScale={2}
                    displayType={'text'} thousandSeparator={true} prefix={this.props.customer.currencyCode === 'CAD' ? 'Selected Credit Amount: CAD ' : 'Selected Credit Amount:$'}
                    />
                        </Typography>}                
                        </Grid>
                        <Grid style={{paddingLeft:'25px'}}  item xs={6}>
                        {totalPaymentAmount > 0 && <Typography variant="subheading">
                    <NumberFormat value={totalPaymentAmount}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        style={{fontWeight: '500', fontStyle: 'italic'}}
                        displayType={'text'} thousandSeparator={true} prefix={this.props.customer.currencyCode === 'CAD' ? 'Total Payable: CAD ':'Total Payable: $'}
                    />
                </Typography>}
                        </Grid>  
                        <Grid style={{paddingRight:'25px'}}  item xs={6}>
                        {totalPayableAmount > 0 && <Typography variant="subheading" align="right">
                    <NumberFormat value={totalPayableAmount}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        style={{fontWeight: '500',color:'#fa451c', fontSize: '1.2rem'}}
                        displayType={'text'} thousandSeparator={true} prefix={this.props.customer.currencyCode === 'CAD'?'Selected Payable: CAD ':'Selected Payable: $'}
                    />
                </Typography>}
                        </Grid>                              
                    </Grid>                                           
            </Paper>
        );
    }
}

PaymentTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    customer: state.auth.customer,
    fetchingcredit: state.credit.fetching,
    paymentAmounts: state.credit.paymentAmounts,
    invoicePaymentAmount:state.invoice.paymentAmounts,
    adhocPaymentEnabled: state.credit.adhocPaymentEnabled,
    credit: state.credit.credit,
    invoices: state.invoice.invoices,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchCredit,
    toggleAllCredit,
    toggleCredit,
    changePaymentAmount
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(withStyles(styles)(PaymentTable)));


const invoiceColumns = [
    {
        id: 'invoiceNumber',
        name: 'Transaction Number',
        display: true,
        mobileDisplay: true,
        disabled: true,
        numeric: false,
    },
    {
        id: 'invoiceDate',
        name: 'Date',
        display: true,
        mobileDisplay: false,
        disabled: false,
        numeric: false,
    },
    {
        id: 'netAmount',
        name: 'Amount',
        display: true,
        mobileDisplay: true,
        disabled: false,
        numeric: true,
    }
];


// WEBPACK FOOTER //
// ./src/PaymentMemoTable.js